import { Link, useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'

import { switchLocalePath } from '@/lib/paths'
import { LOCALES, type Locale } from '@/lib/types'

const LABELS: Record<Locale, string> = { uk: 'УКР', en: 'ENG' }

/**
 * Language switcher.
 *
 * These are real links, not buttons that call setState: each language has its
 * own URL, so the switch has to be something a crawler can follow and a
 * visitor can bookmark or middle-click.
 */
export function LanguageSwitch({ current }: { current: Locale }) {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  return (
    <nav aria-label={t('language.switch')} className="flex items-center gap-1 text-sm">
      {LOCALES.map((locale, index) => (
        <span key={locale} className="flex items-center">
          {index > 0 && <span className="mx-1 text-stone-300">/</span>}
          {locale === current ? (
            <span aria-current="true" className="font-semibold text-stone-900">
              {LABELS[locale]}
            </span>
          ) : (
            <Link
              to={switchLocalePath(pathname, locale)}
              hrefLang={locale}
              className="text-stone-500 transition-colors hover:text-stone-900"
            >
              {LABELS[locale]}
            </Link>
          )}
        </span>
      ))}
    </nav>
  )
}
